module.exports = __webpack_public_path__ + "fonts/Allerta-Regulard3224ae1d32ecfc2bdf33ace4b10badc.ttf";